import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderKinds } from "../../../../actions/community/kindsActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.community.kinds.reorderIds);
  const kinds = useAppSelector(state => state.community.kinds.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderKinds({ ids }));
  }

  return (
    <div className='v-kinds-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={kinds}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
